import React from "react";
import { createRoot } from "react-dom/client";
import { ApolloProvider } from "@apollo/client";
import client from "./apollo-client";
import App from "./App";
import "carbon-components/css/carbon-components.min.css";
import "./i18n";

// 👇 nou
import { ExperienceProvider } from "./context/ExperienceContext";

const root = createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <React.Suspense fallback={null}>
        {/* 👇 învăluim aplicația */}
        <ExperienceProvider>
          <App />
        </ExperienceProvider>
      </React.Suspense>
    </ApolloProvider>
  </React.StrictMode>
);
